<template>
  <div id="app" oncontextmenu="self.event.returnValue=false" onselectstart="return false">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods: {

  },
  created(){
    
    // viewer-container
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue